<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
  <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M24 9v32"/>
  <circle cx="24" cy="17" r="10" fill="#000"/>
  <circle cx="24" cy="17" r="10" stroke="#000" stroke-width="2"/>
</svg>
